import React from "react";
import top from "Assets/Images/top.png";
import contentCounsel from "Assets/Images/contentCounsel.png";

export default class extends React.Component {
  state = {
    loading: true
  };

  componentDidMount() {
    this.setState({ loading: false });
  }

  _goToTop() {
    window.scrollTo(0, 0);
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="contents counsel">
        <img src={contentCounsel} alt="preLoading" className="contentMain" />
        <img
          src={top}
          alt="top"
          className={loading ? "invisible contentTop" : "contentTop"}
          onClick={this._goToTop}
        />
      </div>
    );
  }
}
